/**
 * Shared CraftJS block resolver configuration
 * Used by PageEditorNew and PreviewModal
 */
import { Container, RootContainer } from "../components/blocks/Container";
import { Text } from "../components/blocks/Text";
import { Button } from "../components/blocks/Button";
import { Image } from "../components/blocks/Image";
import { Hero } from "../components/blocks/Hero";
import { ServiceCard } from "../components/blocks/ServiceCard";
import { Services } from "../components/blocks/Services";
import { Doctors } from "../components/blocks/Doctors";
import { DoctorCard } from "../components/blocks/DoctorCard";
import { ContactInfo } from "../components/blocks/ContactInfo";
import { Navbar } from "../components/blocks/Navbar";
import { Footer } from "../components/blocks/Footer";
import { Testimonial } from "../components/blocks/Testimonial";
import { Divider } from "../components/blocks/Divider";
import { Video } from "../components/blocks/Video";
import { FAQ } from "../components/blocks/FAQ";
import { Gallery } from "../components/blocks/Gallery";
import { GoogleMap } from "../components/blocks/GoogleMap";
import { SocialLinks } from "../components/blocks/SocialLinks";
import { ContactForm } from "../components/blocks/ContactForm";
import { FloatingCTA } from "../components/blocks/FloatingCTA";
import { HeroSlider } from "../components/blocks/HeroSlider";
import { BeforeAfter } from "../components/blocks/BeforeAfter";
import { PromotionBanner } from "../components/blocks/PromotionBanner";
// Flexible Navbar blocks
import { NavbarContainer } from "../components/blocks/NavbarContainer";
import { NavLogo } from "../components/blocks/NavLogo";
import { NavMenu } from "../components/blocks/NavMenu";
import { NavCTA } from "../components/blocks/NavCTA";
import { LineLoginButton } from "../components/blocks/LineLoginButton";
import { FlexNavbar } from "../components/blocks/FlexNavbar";
import { PricingCard } from "../components/blocks/PricingCard";
import { FeatureCard } from "../components/blocks/FeatureCard";
import { FilterableFeatures } from "../components/blocks/FilterableFeatures";

/**
 * Block resolver for CraftJS Editor
 * Contains all available block components
 */
export const blockResolver = {
  Container,
  Text,
  Button,
  Image,
  Hero,
  ServiceCard,
  Services,
  Doctors,
  DoctorCard,
  ContactInfo,
  Navbar,
  Footer,
  RootContainer,
  Testimonial,
  Divider,
  Video,
  FAQ,
  Gallery,
  GoogleMap,
  SocialLinks,
  ContactForm,
  FloatingCTA,
  HeroSlider,
  BeforeAfter,
  PromotionBanner,
  // Flexible Navbar blocks
  NavbarContainer,
  NavLogo,
  NavMenu,
  NavCTA,
  LineLoginButton,
  FlexNavbar,
  PricingCard,
  FeatureCard,
  FilterableFeatures,
};

// Re-export RootContainer for Frame usage
export { RootContainer };
